import { FrameData } from "../constants/frameTypes";

export const menuTopFrame: FrameData = {
  name: "menu-top",
  referenceWidth: 500, // Frame width
  referenceHeight: 662.51, // Frame height
  qrPosition: {
    x: 0.1126, // QR left position as % of width, x/w
    y: 0.3303 // QR top position as % of height, y/h
  },
  qrSize: 0.7746, // QR size as % of frame width, qrSize/w
  svgContent: `<path class="st0" d="M463.59,662.51H36.41c-20.06,0-36.41-16.34-36.41-36.41V36.41C0,16.34,16.34,0,36.41,0h427.19c20.06,0,36.41,16.34,36.41,36.41v589.62c0,20.14-16.34,36.48-36.41,36.48Z"/>
  <path class="st1" d="M481.25,198.92c0-9.76-7.9-17.66-17.66-17.66h-147.1l-57.09-51.36-57.01,51.36H36.41c-9.76,0-17.66,7.9-17.66,17.66v427.19c0,9.76,7.9,17.66,17.66,17.66h427.19c9.76,0,17.66-7.9,17.66-17.66V198.92Z"/>
  <rect id="qr_goes_here" class="st1" x="56.31" y="218.82" width="387.3" height="387.3"/>
  <g>
    <path class="st1" d="M173.04,82.65c0-12.63.15-30.6.31-40.59h-.39c-1.7,16.34-5.34,49.5-7.51,66.62h-13.32c-1.78-17.89-5.34-51.59-7.05-66.85h-.46c.23,9.6.62,27.34.62,41.36v25.48h-14.25V26.96h22.54c2.09,15.57,4.49,35.94,5.42,47.02h.31c1.24-11.85,3.95-28.97,6.51-47.02h22.46v81.72h-15.1v-26.03h-.08Z"/>
    <path class="st1" d="M242.6,72.58h-16.89v22.31h19.83l-1.86,13.79h-33.62V26.96h33.46v13.87h-17.74v17.89h16.89v13.87h-.08Z"/>
    <path class="st1" d="M263.36,108.68V26.96h17.43c2.63,9.99,10.77,47.02,11.46,50.58h.39c-.85-10.84-1.39-25.72-1.39-37.18v-13.4h14.56v81.72h-17.58c-1.7-7.75-10.61-50.04-11.15-52.67h-.39c.62,9.6,1.08,25.87,1.08,38.73v13.94h-14.41Z"/>
    <path class="st1" d="M343.22,26.96v62.2c0,4.8,1.47,7.28,5.03,7.28,3.8,0,4.96-2.87,4.96-7.28V26.96h15.88v61.19c0,14.48-6.66,21.61-21.15,21.61s-20.6-6.89-20.6-21.77V26.96h15.88Z"/>
  </g>`
};
